// Whether the live map draws the recent trails of members on the move; on unless
// turned off on the account page. A browser setting, like units.
import { useSyncExternalStore } from "react";

const STORAGE_KEY = "tentwenty.movingTrails";

function readStored(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) !== "off";
  } catch {
    return true;
  }
}

// The choice for this page: localStorage's, or the last one made here if it couldn't be stored.
let current: boolean | undefined;

export function movingTrailsShown(): boolean {
  current ??= readStored();
  return current;
}

const listeners = new Set<() => void>();

export function storeMovingTrailsShown(shown: boolean): void {
  current = shown;
  try {
    if (shown) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, "off");
  } catch {
    // Private browsing: the choice lasts for this page only.
  }
  for (const listener of listeners) listener();
}

if (typeof window !== "undefined") {
  window.addEventListener("storage", (event) => {
    if (event.key !== STORAGE_KEY && event.key !== null) return;
    current = readStored();
    for (const listener of listeners) listener();
  });
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** The account page's moving-trails choice in this browser, kept current across tabs. */
export function useMovingTrailsShown(): boolean {
  return useSyncExternalStore(subscribe, movingTrailsShown);
}
